/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { EmployeeCostsByJobRoleAndLocationSummary } from './EmployeeCostsByJobRoleAndLocationSummary';
import {
    EmployeeCostsByJobRoleAndLocationSummaryFromJSON,
    EmployeeCostsByJobRoleAndLocationSummaryFromJSONTyped,
    EmployeeCostsByJobRoleAndLocationSummaryToJSON,
    EmployeeCostsByJobRoleAndLocationSummaryToJSONTyped,
} from './EmployeeCostsByJobRoleAndLocationSummary';

/**
 * 
 * @export
 * @interface EmployeeCostsByJobRoleAndLocation
 */
export interface EmployeeCostsByJobRoleAndLocation {
    /**
     * A deterministic identifier for the report.
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    employeeId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    startDate: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    endDate: ShiftiePlainDate;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    reference: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    payrollId: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    accountantNumber: string;
    /**
     * The total number of paid hours, excluding overtime
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    totalBasePaidHours: number;
    /**
     * The total number of overtime paid hours
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    totalOvertimePaidHours: number;
    /**
     * Total number of paid hours, including overtime
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    totalPaidHours: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    estimatedTotal: number;
    /**
     * 
     * @type {Array<EmployeeCostsByJobRoleAndLocationSummary>}
     * @memberof EmployeeCostsByJobRoleAndLocation
     */
    costsByJobRoleAndLocation: Array<EmployeeCostsByJobRoleAndLocationSummary>;
}

/**
 * Check if a given object implements the EmployeeCostsByJobRoleAndLocation interface.
 */
export function instanceOfEmployeeCostsByJobRoleAndLocation(value: object): value is EmployeeCostsByJobRoleAndLocation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    if (!('payrollId' in value) || value['payrollId'] === undefined) return false;
    if (!('accountantNumber' in value) || value['accountantNumber'] === undefined) return false;
    if (!('totalBasePaidHours' in value) || value['totalBasePaidHours'] === undefined) return false;
    if (!('totalOvertimePaidHours' in value) || value['totalOvertimePaidHours'] === undefined) return false;
    if (!('totalPaidHours' in value) || value['totalPaidHours'] === undefined) return false;
    if (!('estimatedTotal' in value) || value['estimatedTotal'] === undefined) return false;
    if (!('costsByJobRoleAndLocation' in value) || value['costsByJobRoleAndLocation'] === undefined) return false;
    return true;
}

export function EmployeeCostsByJobRoleAndLocationFromJSON(json: any): EmployeeCostsByJobRoleAndLocation {
    return EmployeeCostsByJobRoleAndLocationFromJSONTyped(json, false);
}

export function EmployeeCostsByJobRoleAndLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeCostsByJobRoleAndLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'startDate': ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': ShiftiePlainDateFromJSON(json['endDate']),
        'reference': json['reference'],
        'payrollId': json['payrollId'],
        'accountantNumber': json['accountantNumber'],
        'totalBasePaidHours': json['totalBasePaidHours'],
        'totalOvertimePaidHours': json['totalOvertimePaidHours'],
        'totalPaidHours': json['totalPaidHours'],
        'estimatedTotal': json['estimatedTotal'],
        'costsByJobRoleAndLocation': ((json['costsByJobRoleAndLocation'] as Array<any>).map(EmployeeCostsByJobRoleAndLocationSummaryFromJSON)),
    };
}

  export function EmployeeCostsByJobRoleAndLocationToJSON(json: any): EmployeeCostsByJobRoleAndLocation {
      return EmployeeCostsByJobRoleAndLocationToJSONTyped(json, false);
  }

  export function EmployeeCostsByJobRoleAndLocationToJSONTyped(value?: EmployeeCostsByJobRoleAndLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'reference': value['reference'],
        'payrollId': value['payrollId'],
        'accountantNumber': value['accountantNumber'],
        'totalBasePaidHours': value['totalBasePaidHours'],
        'totalOvertimePaidHours': value['totalOvertimePaidHours'],
        'totalPaidHours': value['totalPaidHours'],
        'estimatedTotal': value['estimatedTotal'],
        'costsByJobRoleAndLocation': ((value['costsByJobRoleAndLocation'] as Array<any>).map(EmployeeCostsByJobRoleAndLocationSummaryToJSON)),
    };
}

